import * as React from 'react';
import SaleDelete from "~/apps/pos/mobile/components/sales/SaleDelete";
import {useEffect} from "react";
import {deleteSale, getSaleById, getSaleList} from "~/apps/pos/shared/actions/sales";
import Loader from "~/common/components/Loader";
import {connect} from "react-redux";
import {isSaleDeletable} from "~/apps/pos/shared/services/helpers";
import {navigate} from "~/router";
import {createRouteNodeSelector} from "redux-router5";
import {parseSaleStatusFilter} from "~/apps/pos/shared/services/qsfilter";
import {SalesStatusFilter} from "~/apps/pos/models";

type Props = {
  saleId: string;
  sales: any;
  filter: SalesStatusFilter;
  dispatch: any;
  information: any;
}

const DeleteSale = (props: Props) => {
  const { saleId, sales, dispatch, filter, information } = props;

  const sale = sales.entities[saleId];

  useEffect(() => {
    if (!sale) dispatch(getSaleById(saleId));
  }, []);

  const onClose = () => {
    const { q, status } = filter;
    navigate('pos.mobile.history', { q, status });
  }

  useEffect(() => {
    if (sale && !isSaleDeletable(sale.status, sale.paymentType)) onClose();
  }, [sale]);

  if (!sale || sales.ui.loading) {
    return <Loader className="load--ol"/>;
  }

  const onDelete = () => {
    dispatch(deleteSale(saleId)).then(() => {
      dispatch(getSaleList());
      onClose();
    })
  }

  return (
    <SaleDelete
      sale={sale}
      onDelete={onDelete}
      onClose={onClose}
      features={information.entities.features}
    />
  )
}

const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos');
  const { route: { params } } = selector(state);

  const filter = parseSaleStatusFilter(params);

  return {
    sales: state.pos.sales,
    information: state.shared.information,
    filter,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSale)
